import React from 'react';

const FormContainerContext = React.createContext({
	name: '',
});

interface FormContainerContextProviderProps {
	children: React.ReactElement | React.ReactElement[];
	name: string;
}

const FormContainerContextProvider: React.FC<
	FormContainerContextProviderProps
> = props => {
	const { children, name } = props;

	return (
		<FormContainerContext.Provider
			value={{
				name,
			}}>
			{children}
		</FormContainerContext.Provider>
	);
};

export const useFormContainerContext = () =>
	React.useContext(FormContainerContext);

export default FormContainerContextProvider;
